export const categories = new Map([
  [0, [{ id: '6507a3bea08e0912ffecab3d', title: 'искусство' }, { id: '6516e724d6d2ec1c2e7e6807', title: 'космическая техника' }]],
  [1, [{ id: '642ae36261da2e8c789bcc0c', title: 'люди' }, { id: '63cc5e3c60b2c98e5162cd1c', title: 'военная техника' }]],
  [2, [{ id: '63cc57414e17403eb02ed84e', title: 'архитектура' }, { id: '64e721f88586e5c561c95386', title: 'инфраструктура' }]],
])
